<template>
  <div class="timerBar">
    <div class="innerBar is-pulled-right" :style="'width:'+full * 100 + '%'" />
  </div>
</template>

<script>
export default {
  name: 'TimerBar',
  props: ['full']
}
</script>

<style>
  .timerBar {
    height: 3px;
    width: 100%;
  }

  .innerBar {
    height:100%;
    background-color:#ffdd57;
  }
</style>
